import api from './api'

// Types
export type DashboardStats = {
  totalEmployees?: number
  activeEmployees?: number
  inactiveEmployees?: number
  totalModules: number
  totalExams: number
  passedExams: number
  failedExams: number
  skippedExams: number
  totalModuleAssignments?: number
  completedModuleAssignments?: number
  inProgressModuleAssignments?: number
  notStartedModuleAssignments?: number
  currentExams?: number
  upcomingExams?: number
}

export type Activity = {
  id: number | string
  description: string
  timestamp: string
  type: string
  email?: string
  first_name?: string
  last_name?: string
  status?: string
}

export type Exam = {
  id: string
  title: string
  date: string
  status: 'Upcoming' | 'Completed' | 'Skipped'
}

export interface DashboardResponse {
  success: boolean
  data: DashboardStats
}

export interface ActivityResponse {
  success: boolean
  data: Activity[]
}

export const dashboardApi = {
  /**
   * Get dashboard statistics
   */
  getStats: async (): Promise<DashboardStats> => {
    try {
      const response = await api.get<DashboardResponse>('/dashboard/stats')
      return response.data.data
    } catch (error) {
      console.error('Dashboard stats API error:', error)
      throw error
    }
  },

  /**
   * Get recent activity
   */
  getRecentActivity: async (): Promise<Activity[]> => {
    try {
      const response = await api.get<ActivityResponse>('/dashboard/activity')
      return response.data.data
    } catch (error) {
      console.error('Dashboard activity API error:', error)
      throw error
    }
  },

  /**
   * Get exams
   */
  getExams: async (): Promise<Exam[]> => {
    // Replace with your actual API call
    return [
      { id: '1', title: 'HIPAA Training', date: '2025-09-15T10:00:00Z', status: 'Upcoming' },
      { id: '2', title: 'Safety Exam', date: '2025-08-01T10:00:00Z', status: 'Completed' },
      { id: '3', title: 'Compliance Quiz', date: '2025-07-15T10:00:00Z', status: 'Skipped' },
      { id: '3', title: 'First Quiz', date: '2025-07-15T10:00:00Z', status: 'Skipped' }
    ]
  }
}
